module.exports = __webpack_public_path__ + "img/nonhalanhla.11160576.png";